import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { t } from 'keyboard-key';
import { useEffect, useMemo, useRef, useState } from 'react';

export const useCarousel = (contentsList, margin = 24) => {
  const trackRef = useRef(null);
  const progress = useRef(0);
  // ----DRAG----
  const [start, setStart] = useState(0);
  const [change, setChange] = useState(0);

  let flagHandleNext = true;
  let flagHandlePrev = true;
  let flagHandleNextSuper = true;
  let flagHandlePrevSuper = true;

  const handleNext = () => {
    if (!flagHandleNext) return;
    flagHandleNext = false;
    const items = trackRef.current?.childNodes;
    const firstItem = trackRef.current.firstChild;
    trackRef.current.style.transition =
      'transform 0.54s cubic-bezier(0.5, 0, 0.1, 1) 0s';
    trackRef.current.style.transform = `translateX(-${firstItem.offsetWidth +
      24}px)`;

    setTimeout(() => {
      flagHandleNext = true;
      trackRef.current.style.transition = 'none';
      trackRef.current.appendChild(items[0]);
      trackRef.current.style.transform = 'translateX(0px)'; // Restablece posición
    }, 540);
  };

  const handlePrev = () => {
    if (!flagHandlePrev) return;
    flagHandlePrev = false;
    const items = trackRef.current?.childNodes;
    const firstItem = trackRef.current.firstChild;
    trackRef.current.style.transition = 'none';
    trackRef.current.prepend(items[items.length - 1]);
    trackRef.current.style.transform = `translateX(-${firstItem.offsetWidth +
      24}px)`;

    setTimeout(() => {
      flagHandlePrev = true;
    }, 540);

    setTimeout(() => {
      trackRef.current.style.transition =
        'transform 0.54s cubic-bezier(0.5, 0, 0.1, 1) 0s';
      trackRef.current.style.transform = 'translateX(0px)'; // Restablece posición
    }, 54);
  };

  const handleNextSuper = (
    percentageTranslateXInit,
    percentageTranslateX,
    IsSizeMaxDesktop,
  ) => {
    if (!flagHandleNextSuper) return;
    flagHandleNextSuper = false;
    const items = trackRef.current?.childNodes;
    const widthCarrusel = trackRef?.current?.parentNode?.offsetWidth;
    const translateXInit = (widthCarrusel * percentageTranslateXInit) / 100;
    const valueTranslateX = (widthCarrusel * percentageTranslateX) / 100;
    const reajuste = translateXInit * 2;

    trackRef.current.style.transition =
      'transform 0.54s cubic-bezier(0.5, 0, 0.1, 1) 0s';
    if (IsSizeMaxDesktop) {
      trackRef.current.style.transform = `translateX(-${valueTranslateX -
        reajuste}px)`;
    } else {
      trackRef.current.style.transform = `translateX(-${valueTranslateX}px)`;
    }

    setTimeout(() => {
      flagHandleNextSuper = true;
      trackRef.current.style.transition = 'none';
      trackRef.current.appendChild(items[0]);
      trackRef.current.style.transform = `translateX(${translateXInit}px)`; // -- Restablece posición
    }, 540);
  };

  const handlePrevSuper = (
    percentageTranslateXInit,
    percentageTranslateX,
    IsSizeMaxDesktop,
  ) => {
    if (!flagHandlePrevSuper) return;
    flagHandlePrevSuper = false;
    const items = trackRef.current?.childNodes;
    const widthCarrusel = trackRef?.current?.parentNode?.offsetWidth;
    const translateXInit = (widthCarrusel * percentageTranslateXInit) / 100;
    const valueTranslateX = (widthCarrusel * percentageTranslateX) / 100;
    const reajuste = translateXInit * 2;

    trackRef.current.style.transition = 'none';
    trackRef.current.prepend(items[items.length - 1]);
    if (IsSizeMaxDesktop) {
      trackRef.current.style.transform = `translateX(-${valueTranslateX -
        reajuste}px)`;
    } else {
      trackRef.current.style.transform = `translateX(-${valueTranslateX}px)`;
    }

    setTimeout(() => {
      flagHandlePrevSuper = true;
    }, 540);

    setTimeout(() => {
      trackRef.current.style.transition =
        'transform 0.54s cubic-bezier(0.5, 0, 0.1, 1) 0s';
      trackRef.current.style.transform = `translateX(${translateXInit}px)`; // Restablece posición
    }, 54);
  };

  // ----DRAG DEL CARRUSEL----

  const handleDragStart = e => {
    setStart(e.clientX);
    e.dataTransfer.setDragImage(new Image(), 0, 0);
  };

  const handleDragOver = e => {
    e.preventDefault();
    const touch = e.clientX;
    setChange(start - touch);
  };

  const handleDragEnd = () => {
    if (change > 0) {
      handleNext();
    } else {
      handlePrev();
    }
  };

  const calculateWidthPoster = () => {
    try {
      const poster = trackRef?.current?.childNodes?.[0];
      if (poster) {
        const posterStyles = window?.getComputedStyle(poster);
        const widthString = posterStyles?.getPropertyValue('width');
        const marginRightString = posterStyles?.getPropertyValue(
          'margin-right',
        );
        const marginLeftString = posterStyles?.getPropertyValue('margin-left');
        const paddingRightString = posterStyles?.getPropertyValue(
          'padding-right',
        );
        const paddingLeftString = posterStyles?.getPropertyValue(
          'padding-left',
        );

        const width = widthString?.replace('px', '');
        const marginRight = marginRightString?.replace('px', '');
        const marginLeft = marginLeftString?.replace('px', '');
        const ppaddinRight = paddingRightString?.replace('px', '');
        const paddinLeft = paddingLeftString?.replace('px', '');

        const widthNum = Number(width);
        const marginRightNum = Number(marginRight);
        const marginLefttNum = Number(marginLeft);
        const ppaddinRightNum = Number(ppaddinRight);
        const paddinLeftNum = Number(paddinLeft);

        const marginAndPadding =
          marginRightNum + marginLefttNum + ppaddinRightNum + paddinLeftNum;

        const totalWidthPoster = widthNum + marginAndPadding;
        return totalWidthPoster;
      }
      return 0;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  const widthContentsCarouselDreams = () => {
    try {
      const carousel = trackRef?.current?.parentNode;
      if (carousel) {
        const carrouselDreamsStyles = window?.getComputedStyle(carousel);
        const widthCarouselDreamsString = carrouselDreamsStyles?.getPropertyValue(
          'width',
        );
        const widthCarouselDreams = widthCarouselDreamsString.replace('px', '');
        const widthCarouselDreamsNum = Number(widthCarouselDreams);
        return widthCarouselDreamsNum;
      }
      return 0;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  const showArrowScroll = () => {
    try {
      if (!contentsList?.length) return false;
      const windthPoster = calculateWidthPoster();
      const numberOfPosters = contentsList?.length;
      const windthTotalPosters = windthPoster * numberOfPosters;
      const windthCarousel = widthContentsCarouselDreams();

      if (windthTotalPosters > windthCarousel) return true;
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const canDoCarousel = useMemo(
    () => {
      if (
        (trackRef.current && trackRef.current.offsetWidth > screen.width) ||
        contentsList?.length > 6 ||
        showArrowScroll()
      ) {
        return true;
      }
      return false;
    },
    [trackRef?.current?.offsetWidth, contentsList],
  );

  return {
    handleNext,
    handlePrev,
    trackRef,
    handleDragEnd,
    handleDragOver,
    handleDragStart,
    canDoCarousel,
    handleNextSuper,
    handlePrevSuper,
  };
};
